import React from 'react'
import { useRecoilState } from 'recoil'

import Checkbox from '../../../1stlog-ui/src/components/Checkbox'
import { showNewState, showOldState } from './state'

export type TUseOrderDetailV2 = {
  showOld: boolean
  showNew: boolean
  toggleShowOld: () => void
  toggleShowNew: () => void
  checkboxes: React.ReactElement
}

const useOrderDetailV2 = (): TUseOrderDetailV2 => {
  const [showOld, setShowOld] = useRecoilState(showOldState)
  const [showNew, setShowNew] = useRecoilState(showNewState)

  const toggleShowOld = (): void => setShowOld(!showOld)

  const toggleShowNew = (): void => setShowNew(!showNew)

  const checkboxes = (
    <div>
      <div>
        <Checkbox value={showOld} onChange={toggleShowOld}>
          Show old
        </Checkbox>
        <Checkbox value={showNew} onChange={toggleShowNew}>
          Show new
        </Checkbox>
      </div>
    </div>
  )

  return {
    showOld,
    showNew,
    toggleShowOld,
    toggleShowNew,
    checkboxes: <></>,
  }
}

export default useOrderDetailV2
